import axios from "axios";
import { createActionErrorCapture, errorEnvelope } from '../../../../utils/sentryUtils';
import { getToken, getTokenHeader } from "../../../Common/Token";
import { getNetworkListURL, getNetworkPerformanceURL, getNetworkRewardURL, getNetworkSummaryURL } from "../urls";

const captureActionError = createActionErrorCapture('mynetwork');

export const getNetworkListAction = async (payload) => {
  try {
    const params = new URLSearchParams(payload);
    const token = await getToken();
    const { data } = await axios.get(getNetworkListURL(), {
      params: params,
      ...getTokenHeader(token),
    });
    return data;
  } catch (err) {
    captureActionError(err, 'getNetworkListAction');
    return errorEnvelope(err);
  }
};
export const getNetworkSummaryAction = async (payload) => {
  try {
    const params = new URLSearchParams(payload);
    const token = await getToken();
    const { data } = await axios.get(getNetworkSummaryURL(), {
      params: params,
      ...getTokenHeader(token),
    });
    return data;
  } catch (err) {
    captureActionError(err, 'getNetworkSummaryAction');
    return errorEnvelope(err);
  }
};

export const getNetworkPerformanceAction = async (payload) => {
  try {
    const params = new URLSearchParams(payload);
    const token = await getToken();
    const { data } = await axios.get(getNetworkPerformanceURL(), {
      params: params,
      ...getTokenHeader(token),
    });
    return data;
  } catch (err) {
    captureActionError(err, 'getNetworkPerformanceAction');
    return errorEnvelope(err);
  }
};

export const getNetworkRewardAction = async (payload) => {
  try {
    const params = new URLSearchParams(payload);
    const token = await getToken();
    const { data } = await axios.get(getNetworkRewardURL(), {
      params: params,
      ...getTokenHeader(token),
    });
    return data;
  } catch (err) {
    captureActionError(err, 'getNetworkRewardAction');
    return errorEnvelope(err);
  }
};
